<template>
    <div class="pt-1">
        <b-tabs pills active-nav-item-class="nav-pill-warning" nav-class="bg-light p-25 mx-1 custom-nav">
            <b-tab :title="getTitle('Yakınları','EmployeeRelativeInformations')" active>
                <div class="pb-1">
                    <employee-relative-information v-model="value.EmployeeRelativeInformations" :id="id"></employee-relative-information>
                </div>
            </b-tab>
            <b-tab :title="getTitle('Adresler','EmployeeAddresses')">
                <employee-address v-model="value.EmployeeAddresses" :id="id"></employee-address>
            </b-tab>
            <b-tab :title="getTitle('Bedenler','EmployeeSizeInformations')">
                <employee-size-information v-model="value.EmployeeSizeInformations" :id="id"></employee-size-information>
            </b-tab>
            <b-tab :title="getTitle('Bankalar','EmployeeBankAccounts')">
                <employee-bank-account v-model="value.EmployeeBankAccounts" :id="id"></employee-bank-account>
            </b-tab>
            <b-tab :title="getTitle('İletişim Bilgileri','EmployeeContactInfos')" >
                <employee-contact-information v-model="value.EmployeeContactInfos" :id="id" :get-personal="getPersonal" v-on:email-updated="$emit('email-updated')"></employee-contact-information>
            </b-tab>
            <b-tab :title="getTitle('Eğitim','EducationsOfEmployee')">
                <employee-education v-model="value.EducationsOfEmployee" :id="id"></employee-education>
            </b-tab>
            <b-tab :title="getTitle('Askerlik','MilitaryTitlesOfEmployee')">
                <employee-military v-model="value.MilitaryTitlesOfEmployee" :id="id"></employee-military>
            </b-tab>
            <b-tab :title="getTitle('Pasaportlar','Passports')">
                <employee-passport v-model="value.Passports" :id="id"></employee-passport>
            </b-tab>
            <b-tab :title="getTitle('Vizeler','Visas')">
                <employee-visa v-model="value.Visas" :id="id"></employee-visa>
            </b-tab>
        </b-tabs>
        <div class="text-right px-1 pb-1">
            <v-executer :loading="loading" text="Diğer Özlük Bilgilerini Kaydet" :action="save"></v-executer>
        </div>
    </div>
</template>

<script>
import EmployeeRelativeInformation from './relative-information/EmployeeRelativeInformation.vue'
import EmployeeAddress from './address/EmployeeAddress.vue'
import EmployeeSizeInformation from './size-information/EmployeeSizeInformation.vue'
import EmployeeBankAccount from './bank-account/EmployeeBankAccount.vue'
import EmployeeContactInformation from './contact-information/EmployeeContactInformation.vue'
import EmployeePassport from './passport/EmployeePassport.vue'
import EmployeeVisa from './visa/EmployeeVisa.vue'
import EmployeeEducation from './education/EmployeeEducation.vue'
import {BTabs,BTab} from 'bootstrap-vue'
import Additional from '@/utilities/additional'
import EmployeeOperationsApi from '@/api/employee-operations' 
import EmployeeMilitary from './military/EmployeeMilitary.vue'

export default {
    components:{
        EmployeeRelativeInformation,
        EmployeeAddress,
        EmployeeSizeInformation,
        EmployeeBankAccount,
        EmployeeContactInformation,
        EmployeePassport,
        EmployeeVisa,
        EmployeeEducation,
        EmployeeMilitary,
        BTabs,
        BTab
    },
    props:{
        value:Object,
        id:[String,Number],
        getPersonal:Function,
        unsaved:Object,
        candidate:Boolean,
    },
    data(){
        return{
            loading:false,
        }
    },
    methods:{
        async save(){
            const candidateEmployeeId = this.candidate && ![0, "0"].includes(this.id) ? this.id : null
            let data = {
                Step:2,
                EmployeeId:this.id,
                CandidateEmployeeId:candidateEmployeeId,
                ...this.value,
            }
            let formData = await Additional.ToFormData(data)
            this.loading = true
            const submit = this.candidate ? EmployeeOperationsApi.Employee.Candidate.CreateOrUpdate : EmployeeOperationsApi.Employee.CreateOrUpdate
            submit(formData).then(res=>{
                this.$result(res)
                this.loading = false
                if(res.data.Success){
                    this.getPersonal()
                }
            }).catch(err=>{
                this.loading = false
                this.$result(null,err)
            })

        },
        getTitle(title,selector){
            let unsaved = this.unsaved[selector]
            let count = unsaved ? unsaved : 0
            if(count > 0) return [title,"*"].join('')
            else return title
        }
    },
}
</script>

<style>

</style>
